export default "__VITE_ASSET__Ck4UfirT__"